import React, { useState, useEffect } from 'react';
import { Table } from '../../components/tables';
import {
  faultsTableColumns,
} from '../../constants/citypower/constants';
import {
  getAllFaultsTable,
  getColumns,
} from '../../scripts/citypower/tablesScripts';

export const AllFaults = () => {
  const [rows, setRows] = useState(null);
  document.title = 'All Faults | City Power Portal';
  const { headers, headerNames, widths } = faultsTableColumns;
  const columns = getColumns(headers, headerNames, widths);
  const [loading, setLoading] = useState(true);

  const setRowsAsync = async () => {
    setRows(await getAllFaultsTable(faultsTableColumns));
    setLoading(false);
  };

  useEffect(() => {
    // DEV (TODO: delete) >>>
    // if (window.location.origin === "http://localhost:3000") {
    //   console.log("You are on localhost and as such, test data will be used");
    //   setRows(convertRowsForTable(testFaultsTable, faultsTableColumns));
    // } else {
    // <<<
    setRowsAsync();
    // } //DEV (TODO: delete)
  }, []);
  console.log('rows:', rows);

  return <Table title="All Faults" {...{ columns, rows, loading }} />;
};
